<template>
  <single-meeting />
</template>

<script>
import SingleMeeting from "@/components/3pl/CRM/Meetings/SingleMeeting";
export default {
  components: {
    SingleMeeting,
  },
};
</script>

<style></style>
